import * as teamsDarkSiteVariables from '@fluentui/react-northstar/dist/es/themes/teams-dark/siteVariables';
import * as teamsHighContrastSiteVariables from '@fluentui/react-northstar/dist/es/themes/teams-high-contrast/siteVariables';
import * as teamsSiteVariables from '@fluentui/react-northstar/dist/es/themes/teams/siteVariables';
import { mergeSiteVariables } from '@fluentui/react-northstar';

export const defaultVariables = teamsSiteVariables;

export const highContrastVariables = mergeSiteVariables(
  teamsSiteVariables,
  teamsHighContrastSiteVariables
);

export const darkVariables = mergeSiteVariables(
  teamsSiteVariables,
  teamsDarkSiteVariables
);
